import { render, staticRenderFns } from "./DocumentEditor.vue?vue&type=template&id=83e0bd3e&scoped=true&"
import script from "./DocumentEditor.vue?vue&type=script&lang=js&"
export * from "./DocumentEditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditor.vue?vue&type=style&index=0&id=83e0bd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e0bd3e",
  null
  
)

export default component.exports